import React, { useEffect, useState } from 'react';
import { Grid, Collapse } from '@mui/material';
// import { useHistory } from 'react-router-dom';

import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import { useSelector } from 'react-redux';

import Header from '~/components/Header';

import * as Style from './styles';
import { ANIMALE, FABULA, FARM, FOXTON, MARIAFILO} from '~/util/brands';

function ConteudoParaPosts() {
    // const history = useHistory();

    const profile = useSelector(state => state.user.profile);
    const [alternativeBrands, setAlternativeBrands] = useState([]);
    const [brands, setBrands] = useState([]);
    const [marcaPadrao, setMarcaPadrao] = useState(true);
    const [expandedBrand, setExpandedBrand] = useState(null);

    const handleToggleBrand = brandId => {
        setExpandedBrand(expandedBrand === brandId ? null : brandId);
    };

    useEffect(() => {
        const getBrandsFromIdBrand = () => {
            if (profile.marcaFilial) {
                if (profile.marcaFilial === 1) {
                    setAlternativeBrands([6]); //            ANIMALE
                } else if (profile.marcaFilial === 6) {
                    setAlternativeBrands([]); //                OFFPREMIUM
                } else if (profile.marcaFilial === 2) {
                    setAlternativeBrands([5, 7]); //         FARM
                } else if (profile.marcaFilial === 5) {
                    setAlternativeBrands([]); //                FABULA
                } else if (profile.marcaFilial === 7) {
                    setAlternativeBrands([]); //                FOXTON
                } else if (profile.marcaFilial === 9) {
                    setBrands([6, 9]); //                       CRIS BARROS
                    setMarcaPadrao(false);
                } else if (profile.marcaFilial === 15) {
                    setBrands([6, 15]); //                      MARIA FILO
                    setMarcaPadrao(false);
                } else if (
                    profile.marcaFilial === 52 ||
                    profile.marcaFilial === 12
                ) {
                    setBrands([1, 2, 5, 6, 7, 9, 15]); // CORPORATIVO
                    setMarcaPadrao(false);
                }
            } else if (profile.marcaFilialMultimarca) {
                setBrands([1, 2, 5, 6, 7, 15]); 
                setMarcaPadrao(false);
            } else if (profile.id_perfil === 14) {
                setBrands([2]);
                setMarcaPadrao(false);
            } else {
                setBrands([1, 2, 5, 6, 7, 9, 15]);
                setMarcaPadrao(false);
            }
        };
        getBrandsFromIdBrand();
    }, [profile.id_perfil, profile.marcaFilial, profile.marcaFilialMultimarca]);

    const getBrandFromBrands = userBrands => {
        switch (userBrands) {
            case 1:
                return 'Animale';
            case 2:
                return 'Farm';
            case 5:
                return 'Fábula';
            case 6:
                return 'Off Premium';
            case 7:
                return 'Foxton';
            case 9:
                return 'Cris Barros';
            case 15:
                return 'Maria Filó';
            default:
                return '';
        }
    };

    const getDriveLinkFromBrands = userBrands => {
        switch (userBrands) {
            case 1:
                return 'https://drive.google.com/drive/folders/1DLvgHPOjxHyNVpjHbFyabV7MkTbtlHwG';
            case 2:
                return 'https://drive.google.com/drive/folders/1wsGGXabuVSY3dOwWz3k6S5sFMs4T1i0R';
            case 5:
                return 'https://drive.google.com/drive/folders/1551VnR2HT4Z1TJLNSLt7pDr8QnF1Qyaz';
            case 6:
                return 'https://drive.google.com/open?id=1miko-aZlRo8Kedp_XGotb2PJxWl-HNu5';
            case 7:
                return 'https://drive.google.com/drive/folders/1L865afquac4WgHx593y9phUG9NNTQUEK';
            // case 9:
            //     return 'CRIS BARROS';
            // case 15:
            //     return 'MARIA FILÓ';
            default:
                return '';
        }
    };

    const getWhatsAppLinkFromBrands = userBrands => {
        switch (userBrands) {
            case ANIMALE:
                return 'https://chat.whatsapp.com/G2wggnHUzKV8xijvoqnsiF?mode=gi_t';
            case 'ANIMALE_JEANS':
                return 'https://chat.whatsapp.com/LLnuJjafrk9K07vdyCTKkx?mode=gi_t';
            case FARM:
                return 'https://chat.whatsapp.com/KDooTaWe4YVFMZmyQ76RFm';
            case MARIAFILO:
                return 'https://chat.whatsapp.com/CquvdIRdwo29MXhDa9pJgw?mode=gi_t';
            case FABULA:
                return 'https://chat.whatsapp.com/BsHpuKwT6zwCwbkUXBlwc7?mode=gi_t';
            case FOXTON:
                return 'https://chat.whatsapp.com/G9gUYAge3UALUdvoFVhngs';
            default:
                return null;
        }
    };

    return (
        <>
            <Header />

            {marcaPadrao === true ? (
                <Style.ContentContainer container>
                    <Grid item xs={12}>
                        <Style.BrandContainer
                            container
                            onClick={() => {
                                window.open(
                                    getDriveLinkFromBrands(profile.marcaFilial),
                                    '_blank'
                                );
                            }}
                        >
                            <Grid item>
                                <Style.BrandName>
                                    {getBrandFromBrands(profile.marcaFilial)}
                                </Style.BrandName>
                            </Grid>
                            <Style.Icon item>
                                <ChevronRightOutlinedIcon />
                            </Style.Icon>
                        </Style.BrandContainer>
                    </Grid>

                    {alternativeBrands
                        .filter(
                            prohibitedBrands =>
                                prohibitedBrands !== 9 &&
                                prohibitedBrands !== 15
                        )
                        .map(brand => (
                            <Style.ListItem item key={brand}>
                                <Style.BrandContainer
                                    container
                                    onClick={() => {
                                        window.open(
                                            getDriveLinkFromBrands(brand),
                                            '_blank'
                                        );
                                    }}
                                >
                                    <Grid item>
                                        <Style.BrandName>
                                            {getBrandFromBrands(brand)}
                                        </Style.BrandName>
                                    </Grid>
                                    <Style.Icon item>
                                        <ChevronRightOutlinedIcon />
                                    </Style.Icon>
                                </Style.BrandContainer>
                            </Style.ListItem>
                        ))}
                </Style.ContentContainer>
            ) : (
                <Style.ContentContainer container>
                    {
                    brands
                    .filter(prohibitedBrands => prohibitedBrands !== 9)
                        .map(brand => {
                            const hasWhatsApp = getWhatsAppLinkFromBrands(brand);
                            const hasDrive = getDriveLinkFromBrands(brand);

                            return (
                                <Style.ListItem item key={brand}>
                                    <Style.BrandContainer
                                        container
                                        onClick={() => handleToggleBrand(brand)}
                                        style={{
                                            borderBottomLeftRadius:
                                                expandedBrand === brand ? 0 : 4,
                                            borderBottomRightRadius:
                                                expandedBrand === brand ? 0 : 4,
                                        }}
                                    >
                                        <Grid item>
                                            <Style.BrandName>
                                                {getBrandFromBrands(brand)}
                                            </Style.BrandName>
                                        </Grid>
                                        <Style.Icon item>
                                            {expandedBrand === brand ? (
                                                <KeyboardArrowDownOutlinedIcon />
                                            ) : (
                                                <ChevronRightOutlinedIcon />
                                            )}
                                        </Style.Icon>
                                    </Style.BrandContainer>
                                    <Collapse in={expandedBrand === brand}>
                                        <Style.DropdownContent>
                                            {hasWhatsApp && (
                                                <Style.DropdownItem
                                                    onClick={() => {
                                                        window.open(hasWhatsApp, '_blank');
                                                    }}
                                                >
                                                    Grupo oficial de comunicados
                                                </Style.DropdownItem>
                                            )}

                                            {hasDrive && (
                                                <Style.DropdownItem
                                                    onClick={() => {
                                                        window.open(hasDrive, '_blank');
                                                    }}
                                                >
                                                    Conteúdos da marca
                                                </Style.DropdownItem>
                                            )}

                                            {brand === ANIMALE && (
                                                <>
                                                    <Style.DropdownItem
                                                        style={{
                                                            marginTop: 8,
                                                            borderTop: '1px solid #555',
                                                            paddingTop: 16,
                                                        }}
                                                        onClick={() => {
                                                            const link = getWhatsAppLinkFromBrands(
                                                                'ANIMALE_JEANS'
                                                            );
                                                            if (link) window.open(link, '_blank');
                                                        }}
                                                    >
                                                        Grupo oficial de comunicados | Animale Jeans
                                                    </Style.DropdownItem>
                                                </>
                                            )}
                                        </Style.DropdownContent>
                                    </Collapse>
                                </Style.ListItem>
                            );
                        })}
                </Style.ContentContainer>
            )}
        </>
    );
}

export default ConteudoParaPosts;